import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { SubPartnersKobHoved, Ta1AdminKobhoved } from '../../../app/models/partners';
import NewPartnerForm from '../forms/NewPartnerForm';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import ExistingPartnerForm from '../forms/ExistingPartnerForm';
import GenerateReportHeading from '../../../app/common/reportsHeading/GenerateReportHeading';

interface Props {
    selectedKobhoveds: Ta1AdminKobhoved[] | SubPartnersKobHoved[];
    backBtnHandler: () => void;
}

const NewT1aPartnerFormContainer = ({ selectedKobhoveds, backBtnHandler }: Props) => {

    const [newForm, setNewForm] = useState(true);
    const [existingForm, setExistingForm] = useState(false);

    const newFormHandler = () => {
        setExistingForm(false);
        setNewForm(!newForm);
    }
    const existingFormHandler = () => {
        setNewForm(false);
        setExistingForm(!existingForm);
    }

    return (
        <Box component={'div'}>
            <GenerateReportHeading heading='Create or Edit user here' />
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="new"
            >
                <Box component={'div'} sx={{ m: '10px auto' }}>
                    <FormControlLabel value="new" control={<Radio onChange={newFormHandler} />} label="New" />
                    <FormControlLabel value="existing" control={<Radio onChange={existingFormHandler} />} label="Existing " />
                </Box>
            </RadioGroup>
            <Box>
                {newForm ?
                    <NewPartnerForm selectedKobhoveds={selectedKobhoveds} backBtnHandler={backBtnHandler} />
                    :
                    <ExistingPartnerForm selectedKobhoveds={selectedKobhoveds} backBtnHandler={backBtnHandler} />
                }
            </Box>
        </Box>
    );
}
export default observer(NewT1aPartnerFormContainer);